document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-menu-toggle]').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const menu = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!menu) return;
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
      document.body.classList.toggle('menu-open', !open);
    });
  });

  document.querySelectorAll('[data-quantity-change]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = document.getElementById(button.getAttribute('aria-controls'));
      if (!input) return;
      const step = button.dataset.quantityChange === 'increase' ? 1 : -1;
      input.value = Math.max(0, Number(input.value || 0) + step);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.querySelectorAll('[data-load-more-section]').forEach((section) => {
    const button = section.querySelector('[data-load-more]');
    if (!button) return;

    button.addEventListener('click', () => {
      const hiddenItems = Array.from(section.querySelectorAll('[data-load-more-item][hidden]'));
      const revealCount = Number(button.dataset.loadMoreStep || 8);
      const nextItems = hiddenItems.slice(0, revealCount);

      nextItems.forEach((item) => {
        item.hidden = false;
      });

      if (!section.querySelector('[data-load-more-item][hidden]')) {
        button.closest('.load-more-wrap').hidden = true;
      }

      if (nextItems[0]) {
        window.requestAnimationFrame(() => {
          nextItems[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    });
  });
});
